<mat-toolbar-row>

    <a mat-button routerLink="/inspections/recurrent" routerLinkActive="active">Wiederholungen</a>
    <a mat-button routerLink="/inspections/all" routerLinkActive="active">Übersicht</a>
    <a mat-button routerLink="/inspections/planned" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">Geplant</a>
    <backoffice-planning-excel-upload-button/>
    <backoffice-planning-excel-download-button/>

</mat-toolbar-row>
